// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2cmXk","header":"ReportDetails_header__x43qD","title":"ReportDetails_title__1tD8l","left":"ReportDetails_left__3TMOB"};